import apiService from './api';
import { todayYmd } from '../utils/appTimezone';

const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const rendezVousService = {
  async list(params = {}) {
    return apiService.get('/rendez-vous', { params });
  },

  async getById(id) {
    return apiService.get(`/rendez-vous/${id}`);
  },

  async create(payload) {
    return apiService.post('/rendez-vous', payload);
  },

  async update(id, payload) {
    return apiService.put(`/rendez-vous/${id}`, payload);
  },

  async confirm(id) {
    return apiService.post(`/rendez-vous/${id}/confirm`, {});
  },

  async finish(id) {
    return apiService.post(`/rendez-vous/${id}/finish`, {});
  },

  async cancel(id, reason) {
    return apiService.post(`/rendez-vous/${id}/cancel`, { reason });
  },

  async absent(id) {
    return apiService.post(`/rendez-vous/${id}/absent`, {});
  },

  async calendar(params = {}) {
    return apiService.get('/rendez-vous/calendar', { params });
  },

  async availability(params = {}) {
    return apiService.get('/rendez-vous/availability', { params });
  },

  async registerVisit(id, payload = {}) {
    return apiService.post(`/rendez-vous/${id}/register-visit`, payload);
  },

  async doctors() {
    return apiService.get('/rendez-vous/doctors');
  },

  /** Télécharge le CSV des RDV (mêmes filtres que la liste, sans pagination). */
  async downloadCsv(filters = {}) {
    const params = new URLSearchParams();
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    if (filters.status) params.append('status', filters.status);
    if (filters.type_rendez_vous) params.append('type_rendez_vous', filters.type_rendez_vous);
    if (filters.search) params.append('search', String(filters.search).trim());
    const qs = params.toString();
    const token =
      typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('token') : null;
    const url = `${API_ROOT}/rendez-vous/export.csv${qs ? `?${qs}` : ''}`;
    const r = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!r.ok) {
      let msg = 'Export CSV impossible.';
      try {
        const data = await r.json();
        if (data.message) msg = data.message;
      } catch (_) {
        /* ignore non-JSON error body */
      }
      throw new Error(msg);
    }
    const blob = await r.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `rdv-export-${todayYmd()}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
  }
};

export default rendezVousService;
